export const DRAFTS_LOG = { system: true, capture: 'whiteboard-drafts' } as const;

export const DRAFTS_TAG = 'whiteboard-drafts';
